import { chatmonitoringConstants } from '../constants';

const initialState = {
    loading: false,
    activeclasses: [],
    activestudents: [],
    activeStudentsClassID: null,
    requestedActiveStudentsClassID: null,
    flaggedmessages: [],
    flaggedMessagesClassID: null,
    requestedFlaggedMessagesClassID: null,
    reportedmessages: [],
    reportedMessagesClassID: null,
    requestedReportedMessagesClassID: null,
    chatuser: [],
    chatUserClassID: null,
    requestedChatUserClassID: null,
    appconfigs: [],
    error: null
};

const chatmonitoringReducer = (state = initialState, action) => {
    switch (action.type) {
        case chatmonitoringConstants.FETCH_ACTIVECLASSES_REQUEST:
            return {
                ...state,
                loading: true
            };
        case chatmonitoringConstants.FETCH_ACTIVECLASSES_SUCCESS:
            return {
                ...state,
                activeclasses: action.activeclasses,
                loading: false
            };
        case chatmonitoringConstants.FETCH_ACTIVECLASSES_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        case chatmonitoringConstants.GET_ACTIVECLASSSTUDENTS_REQUEST:
            return {
                ...state,
                requestedActiveStudentsClassID: action.classId,
                loading: true
            };
        case chatmonitoringConstants.GET_ACTIVECLASSSTUDENTS_SUCCESS:
            if (state.requestedActiveStudentsClassID !== action.classId) {
                return state;
            }

            return {
                ...state,
                activestudents: action.activestudents,
                activeStudentsClassID: action.classId,
                loading: false
            };
        case chatmonitoringConstants.GET_ACTIVECLASSSTUDENTS_FAILURE:
            if (state.requestedActiveStudentsClassID !== action.classId) {
                return state;
            }

            return {
                ...state,
                activestudents: [],
                activeStudentsClassID: null,
                error: action.error,
                loading: false
            };
        case chatmonitoringConstants.FETCH_FLAGGEDMESSAGES_REQUEST:
            return {
                ...state,
                requestedFlaggedMessagesClassID: action.classId,
                loading: true
            };
        case chatmonitoringConstants.FETCH_FLAGGEDMESSAGES_SUCCESS:
            if (state.requestedFlaggedMessagesClassID !== action.classId) {
                return state;
            }

            return {
                ...state,
                flaggedmessages: action.flaggedmessages,
                flaggedMessagesClassID: action.classId,
                loading: false
            };
        case chatmonitoringConstants.FETCH_FLAGGEDMESSAGES_FAILURE:
            if (state.requestedFlaggedMessagesClassID !== action.classId) {
                return state;
            }

            return {
                ...state,
                flaggedmessages: [],
                flaggedMessagesClassID: null,
                error: action.error,
                loading: false
            };
        case chatmonitoringConstants.FETCH_REPORTEDMESSAGES_REQUEST:
            return {
                ...state,
                requestedReportedMessagesClassID: action.classId,
                loading: true
            };
        case chatmonitoringConstants.FETCH_REPORTEDMESSAGES_SUCCESS:
            if (state.requestedReportedMessagesClassID !== action.classId) {
                return state;
            }

            return {
                ...state,
                reportedmessages: action.reportedmessages,
                reportedMessagesClassID: action.classId,
                loading: false
            };
        case chatmonitoringConstants.FETCH_REPORTEDMESSAGES_FAILURE:
            if (state.requestedReportedMessagesClassID !== action.classId) {
                return state;
            }

            return {
                ...state,
                reportedmessages: [],
                reportedMessagesClassID: null,
                error: action.error,
                loading: false
            };
        case chatmonitoringConstants.UPDATE_STUDENTBLOCKS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case chatmonitoringConstants.UPDATE_STUDENTBLOCKS_SUCCESS:
            return {
                ...state,
                activestudents: state.activestudents.map(student => {
                    const updatedBlock = action.studentblocks.find(
                        block => block.studentProfileId === student.StudentProfileID
                    );
                    if (updatedBlock) {
                        return {
                            ...student,
                            BlockChat: updatedBlock.blockChat,
                            BlockGame: updatedBlock.blockGame
                        };
                    }
                    return student;
                }),
                loading: false
            };
        case chatmonitoringConstants.UPDATE_STUDENTBLOCKS_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        case chatmonitoringConstants.UPDATE_AWARDCOINS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case chatmonitoringConstants.UPDATE_AWARDCOINS_SUCCESS:
            const updatedStudents = state.activestudents.map(student =>
                student.StudentProfileID === action.awardedcoins.StudentProfileID
                    ? {
                        ...student,
                        CoinsCount: (Number(student.CoinsCount) + Number(action.awardedcoins.CoinsCount))
                    }
                    : student
            );
            return {
                ...state,
                activestudents: updatedStudents,
                loading: false
            };
        case chatmonitoringConstants.UPDATE_AWARDCOINS_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            };

        case chatmonitoringConstants.FETCH_CHATUSERNAME_REQUEST:
            return {
                ...state,
                requestedChatUserClassID: action.classId,
                loading: true
            };
        case chatmonitoringConstants.FETCH_CHATUSERNAME_SUCCESS:
            if (state.requestedChatUserClassID !== action.classId) {
                return state;
            }

            return {
                ...state,
                chatuser: action.chatuser,
                chatUserClassID: action.classId,
                loading: false
            };
        case chatmonitoringConstants.FETCH_CHATUSERNAME_FAILURE:
            if (state.requestedChatUserClassID !== action.classId) {
                return state;
            }

            return {
                ...state,
                chatUserClassID: null,
                error: action.error,
                loading: false
            };
        case chatmonitoringConstants.UPDATE_CHATUSERNAME_REQUEST:
            return {
                ...state,
                loading: true
            };
        case chatmonitoringConstants.UPDATE_CHATUSERNAME_SUCCESS:
            return {
                ...state,
                chatuser: action.chatuser,
                loading: false
            };
        case chatmonitoringConstants.UPDATE_CHATUSERNAME_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        case chatmonitoringConstants.FETCH_APPCONFIGS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case chatmonitoringConstants.FETCH_APPCONFIGS_SUCCESS:
            return {
                ...state,
                appconfigs: action.appconfigs,
                loading: false
            };
        case chatmonitoringConstants.FETCH_APPCONFIGS_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        case chatmonitoringConstants.HYDRATE_CHATMONITORING_DATA:
            return {
                ...state,
                activestudents: action.payload.activestudents,
                activeStudentsClassID: action.payload.loaded?.activestudents ? action.payload.classId : null,
                requestedActiveStudentsClassID: action.payload.classId || null,
                flaggedmessages: action.payload.flaggedmessages,
                flaggedMessagesClassID: action.payload.loaded?.flaggedmessages ? action.payload.classId : null,
                requestedFlaggedMessagesClassID: action.payload.classId || null,
                reportedmessages: action.payload.reportedmessages,
                reportedMessagesClassID: action.payload.loaded?.reportedmessages ? action.payload.classId : null,
                requestedReportedMessagesClassID: action.payload.classId || null,
                chatuser: action.payload.chatuser,
                chatUserClassID: action.payload.loaded?.chatuser ? action.payload.classId : null,
                requestedChatUserClassID: action.payload.classId || null,
                loading: false,
                error: null
            };
        case chatmonitoringConstants.RESET_CHATMONITORING_DATA:
            return {
                ...state,
                activestudents: [],
                activeStudentsClassID: null,
                requestedActiveStudentsClassID: null,
                flaggedmessages: [],
                flaggedMessagesClassID: null,
                requestedFlaggedMessagesClassID: null,
                reportedmessages: [],
                reportedMessagesClassID: null,
                requestedReportedMessagesClassID: null,
                chatuser: [],
                chatUserClassID: null,
                requestedChatUserClassID: null,
                error: null,
                loading: false
            };
        default:
            return state;
    }
};

export default chatmonitoringReducer;
